const TMDB_LOGO_WIDTHS = [500, 300, 185, 154, 92, 45];

function numericValue(value) {
    const parsed = Number(value);
    return isNaN(parsed) ? 0 : parsed;
}

function compareLogos(left, right) {
    const voteAverageDifference = numericValue(right.vote_average) - numericValue(left.vote_average);
    if (voteAverageDifference !== 0) {
        return voteAverageDifference;
    }

    const voteCountDifference = numericValue(right.vote_count) - numericValue(left.vote_count);
    if (voteCountDifference !== 0) {
        return voteCountDifference;
    }

    const leftResolution = numericValue(left.width) * numericValue(left.height);
    const rightResolution = numericValue(right.width) * numericValue(right.height);
    return rightResolution - leftResolution;
}

export function selectBestTitleLogo(logos) {
    const candidates = Array.isArray(logos)
        ? logos.filter(logo => logo && logo.file_path)
        : [];
    const englishLogos = candidates.filter(logo => String(logo.iso_639_1 || '').toLowerCase() === 'en');
    const untaggedLogos = candidates.filter(logo => logo.iso_639_1 === null || logo.iso_639_1 === undefined || logo.iso_639_1 === '');
    const preferredLogos = englishLogos.length > 0 ? englishLogos : untaggedLogos;

    return preferredLogos.slice().sort(compareLogos)[0] || null;
}

export function getTmdbLogoSize(logo) {
    const sourceWidth = numericValue(logo && logo.width);

    for (let i = 0; i < TMDB_LOGO_WIDTHS.length; i++) {
        if (sourceWidth >= TMDB_LOGO_WIDTHS[i]) {
            return `w${TMDB_LOGO_WIDTHS[i]}`;
        }
    }

    return 'original';
}

export function getTitleLogoSelection(images) {
    const logo = selectBestTitleLogo(images && images.logos);

    if (!logo) {
        return {filePath: null, size: null};
    }

    return {
        filePath: logo.file_path,
        size: getTmdbLogoSize(logo)
    };
}

export function sanitizeImageFilename(filename) {
    const pathParts = String(filename || '').split(/[\\/]/);
    const leafName = pathParts[pathParts.length - 1];
    const sanitized = leafName
        .trim()
        .replace(/\s+/g, '_')
        .replace(/[^A-Za-z0-9._-]/g, '_')
        .replace(/^\.+/, '');

    return sanitized || 'title-logo.png';
}

export function getTitleLogoFilename(filePath, size) {
    return `title_${size || 'original'}_${sanitizeImageFilename(filePath)}`;
}
